var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-container',[_c('main',[_c('div',[_c('router-view')],1)]),(!_vm.isFetchingSettings)?_c('c-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }